import { Redirect } from "react-router-dom";

import {
  LoginPage,
  LogoutPage,
  ForgetPasswordPage,
  VerificationPage,
  GovernoratesPage,
  CitiesPage,
  SchoolsPage,
  ResetPasswordPage,
  SemestersTabsPage,
  SettingsTabPage,
  ControlAppTabsPage,
  SubjectsTabPage,
  SubjectDetailPage,
  AdminTeachersPage,
  PromoCodePage,
  TeacherUsersPage,
  TeacherAdminDashboard,
  ComplaintsPage,
  TransactionHistoryPage,
  ReportsPage,
  EnableDisablePage,
  AISetupPage,
  PlansTabPage,
  StudentUsersV2Page,
  TransactionHistoryV2Page,
  ReportsV2Page,
} from "../pages";
import Alt404 from "../pages/AuthenticationInner/Errors/Alt404";
import { OlympicTabsPage } from "../pages/Olympic/OlympicTabsPage";
import { StudentUsersPage } from "../pages/Users/AppUsers/StudentUsers";
import { ParentUsersPage } from "../pages/Users/AppUsers/ParentUsers";
import AdminDashboardPage from "../pages/Dashboards/AdminDashboard/AdminDashboard";
import NotifyUsersPage from "../pages/NotifyUsers/NotifyUsers";
import { NotificationsPage } from "../pages/NotifyUsers";
import AdminDashboardV2Page from "../pages/Dashboards/AdminDashboardV2/AdminDashboardV2";

export const SuperAdminRoutes: any[] = [
  { path: "/dashboard", component: AdminDashboardPage },
  { path: "/dashboard-v2", component: AdminDashboardV2Page },
  { path: "/governorates", component: GovernoratesPage },
  { path: "/cities", component: CitiesPage },
  { path: "/schools", component: SchoolsPage },
  { path: "/subjects/first-course", component: SubjectsTabPage },
  { path: "/subjects/second-course", component: SubjectsTabPage },
  {
    path: "/subjects/details/:id",
    component: SubjectDetailPage,
  },
  { path: "/control-app/content-price", component: ControlAppTabsPage },
  { path: "/control-app/enable-disable", component: EnableDisablePage },
  { path: "/control-app/ai-setup", component: AISetupPage },
  { path: "/semesters", component: SemestersTabsPage },
  { path: "/settings", component: SettingsTabPage },
  { path: "/olympiad", component: OlympicTabsPage },
  { path: "/olympiad/:courseId", component: OlympicTabsPage },
  {
    path: "/olympiad/questions/:courseId/:olympicId",
    component: OlympicTabsPage,
  },
  {
    path: "/olympiad/participants/:courseId/:olympicId",
    component: OlympicTabsPage,
  },
  { path: "/users/cp-users/teachers", component: AdminTeachersPage },
  { path: "/users/app-users/students", component: StudentUsersPage },
  { path: "/users/app-users/students-v2", component: StudentUsersV2Page },
  { path: "/users/app-users/parents", component: ParentUsersPage },
  { path: "/users/app-users/teachers", component: TeacherUsersPage },
  { path: "/payment/transaction-history", component: TransactionHistoryPage },
  {
    path: "/payment/transaction-history-v2",
    component: TransactionHistoryV2Page,
  },
  { path: "/payment/promo-codes", component: PromoCodePage },
  { path: "/payment/plans/first-course", component: PlansTabPage },
  { path: "/payment/plans/second-course", component: PlansTabPage },
  { path: "/notifications/notify", component: NotifyUsersPage },
  { path: "/notifications/list", component: NotificationsPage },
  { path: "/complaints", component: ComplaintsPage },
  { path: "/reports", component: ReportsPage },
  { path: "/reports-v2", component: ReportsV2Page },
  {
    path: "/",
    exact: true,
    component: () => <Redirect to="/dashboard" />,
  },

  { path: "not-found", component: Alt404 },
  { path: "*", exact: true, component: Alt404 },
];

export const TeacherAdminRoutes: any[] = [
  { path: "/dashboard", component: TeacherAdminDashboard },

  { path: "/subjects/first-course", component: SubjectsTabPage },
  { path: "/subjects/second-course", component: SubjectsTabPage },
  {
    path: "/subjects/details/:id",
    component: SubjectDetailPage,
  },
  { path: "/settings", component: SettingsTabPage },
  { path: "/olympiad", component: OlympicTabsPage },
  { path: "/olympiad/:courseId", component: OlympicTabsPage },
  {
    path: "/olympiad/questions/:courseId/:olympicId",
    component: OlympicTabsPage,
  },
  {
    path: "/olympiad/participants/:courseId/:olympicId",
    component: OlympicTabsPage,
  },
  {
    path: "/",
    exact: true,
    component: () => <Redirect to="/dashboard" />,
  },
  { path: "not-found", component: Alt404 },
  { path: "*", exact: true, component: Alt404 },
];

export const PublicRoutes: any = [
  { path: "/login", component: LoginPage },
  { path: "/logout", component: LogoutPage },
  { path: "/forget-password", component: ForgetPasswordPage },
  {
    path: "/verification/:phone",
    component: VerificationPage,
  },
  {
    path: "/reset-password/:phone/:code",
    component: ResetPasswordPage,
  },
];
